import { Alert } from "antd"

const ErrorAlert = ({ error }) => {
    return (
        <Alert message={error} type="error" showIcon />
    )
}

export default ErrorAlert